export const getDiscountModels = ({ discounts, coupons, promotionCodes }) => {
  const couponIds =
    discounts && discounts.map && discounts.map(({ coupon }) => coupon);

  const hasCouponIds = couponIds && couponIds.length > 0;
  const couponMatches =
    coupons &&
    coupons.filter &&
    hasCouponIds &&
    coupons.filter(({ id }) => couponIds.indexOf(id) > -1);

  const promotionCodeIds =
    discounts &&
    discounts.map &&
    discounts.map(({ promotion_code }) => promotion_code);
  const hasPromoIds = promotionCodeIds && promotionCodeIds.length > 0;
  const codeMatches =
    promotionCodes &&
    promotionCodes.filter &&
    hasPromoIds &&
    promotionCodes.filter(({ id }) => promotionCodeIds.indexOf(id) > -1);

  return {
    coupons: couponMatches,
    promotionCodes: codeMatches
  };
};
